import {DashboardLayout} from '@/modules/layout/ components/dashboard-layout'
import {useGetOrganisations} from '@/modules/organisations/api'
import {OrganisationsTable} from '@/modules/organisations/components'
import {ResourcesIndexPageHeader} from '@/shared/components/ui/resources-index-page-header'
import {ResourcesIndexPageTable} from '@/shared/components/ui/resources-index-page-table'
import {OrganisationStatus, OrganisationType} from '@cypro/admin-engine/database/schema'
import {Organisation} from '@cypro/admin-engine/schema'
import {createFileRoute} from '@tanstack/react-router'
import {useTranslate} from '@tolgee/react'
import {useCallback} from 'react'
import * as z from 'zod'

const SearchSchema = z.object({
  filters: z
    .object({
      search: z.string().optional(),
      status: OrganisationStatus.optional(),
      type: OrganisationType.optional(),
    })
    .optional(),
})

export const Route = createFileRoute('/organisations/')({
  component: OrganisationsPage,
  validateSearch: SearchSchema,
})

const LIMIT = 200

function OrganisationsPage() {
  const {t} = useTranslate('organisations')
  const search = Route.useSearch()

  const {organisations, meta, anchor, fetchMore} = useGetOrganisations({
    limit: LIMIT,
    sort: {
      dir: 'desc',
      field: 'createdAt',
    },
    filters: {
      search: search.filters?.search,
      status: search.filters?.status,
      type: search.filters?.type,
    },
  })

  const canFetchMore = organisations.length === LIMIT

  const onRowClick = useCallback((_organisation: Organisation) => {
    // TODO: open organisation drawer
  }, [])

  return (
    <DashboardLayout>
      <ResourcesIndexPageHeader title={t('page_title')} description={t('page_desc')} addNewTo="/organisations/new">
        {/* TODO: add filters */}
      </ResourcesIndexPageHeader>

      <ResourcesIndexPageTable>
        <OrganisationsTable
          organisations={organisations}
          anchor={anchor}
          fetchMore={fetchMore}
          isFetching={meta.type === 'unknown'}
          canFetchMore={canFetchMore}
          pageSize={LIMIT}
          onRowClick={onRowClick}
        />
      </ResourcesIndexPageTable>
    </DashboardLayout>
  )
}
